export enum ApiEnum {
  LOGIN_BASE_URL = '/api/auth',
  MEETING_URL = '/api/meetings',
  MEETING_V2_URL = '/api/v2/meetings',
  DASHBOARD_URL = '/api/dashboard',
  ENQUIRY_URL = '/api/enquiry',
  CUSTOMER_BASE_URL = '/api/customer',
  CUSTOMER_V2_BASE_URL = '/api/v2/customer',
  CONTENT_SHARING_BASE_URL = '/api/sharing',
  MSIL = 'api/msil',
  MASTER_URL = '/api/masters',
  MSSF_URL = '/api/mssf',
  WEBEX_URL = '/api/v1/webex',
}
